module.exports = __webpack_public_path__ + "img/feedback-bg.22706f90.jpg";